var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/dots_on"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.927 14.567a2.696 2.696 0 0 1 2.684 2.698 2.696 2.696 0 0 1-2.684 2.699 2.696 2.696 0 0 1-2.685-2.699 2.696 2.696 0 0 1 2.685-2.698Zm0-10.53A2.696 2.696 0 0 1 9.61 6.735a2.696 2.696 0 0 1-2.684 2.699 2.696 2.696 0 0 1-2.685-2.699 2.696 2.696 0 0 1 2.685-2.698Zm10.147 10.53a2.696 2.696 0 0 1 2.684 2.698 2.697 2.697 0 0 1-2.684 2.699 2.696 2.696 0 0 1-2.685-2.699 2.696 2.696 0 0 1 2.685-2.698Zm0-10.53a2.697 2.697 0 0 1 2.684 2.698 2.697 2.697 0 0 1-2.684 2.699 2.696 2.696 0 0 1-2.685-2.699 2.696 2.696 0 0 1 2.685-2.698Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsOn);
export default __webpack_public_path__ + "static/media/dots_on.9d9b897bf60bf0f68888f503ae559338.svg";
export { ForwardRef as ReactComponent };